// extracted by mini-css-extract-plugin
export default {"noMargin":"studentApplication_noMargin__rUteW","ThisModal":"studentApplication_ThisModal__CHDgY"};